<img src="/assets/img/icons/weight.svg" alt="Súlyozás" [width]="size" [height]="size">
<div class="weight-value" [style.--size.px]="size">{{ weight }}</div>